<template>
  <div class="c-weektime" :class="{ disabled: disabled }">
    <div class="c-schedue"></div>
    <div :class="{ 'c-schedue': true, 'c-schedue-notransi': mode }" :style="styleValue"></div>

    <table class="c-weektime-table" :class="{ 'c-min-table': colspan < 2 }">
      <thead class="c-weektime-head">
        <tr>
          <th rowspan="8" class="week-td">星期/时间</th>
          <th :colspan="12 * colspan">00:00 - 12:00</th>
          <th :colspan="12 * colspan">12:00 - 24:00</th>
        </tr>
        <tr>
          <td v-for="t in theadArr" :key="t" :colspan="colspan">{{ t }}</td>
        </tr>
      </thead>
      <tbody class="c-weektime-body">
        <template>
          <tr v-for="t in weektimeData" :key="t.row">
            <td>{{ t.value }}</td>
            <td
              v-for="n in t.child"
              :key="`${n.row}-${n.col}`"
              :data-week="n.row"
              :data-time="n.col"
              @mouseenter="cellEnter(n)"
              @mousedown="cellDown(n)"
              @mouseup="cellUp(n)"
              :class="selectClasses(n)"
              class="weektime-atom-item"
            ></td>
          </tr>
        </template>
        <tr v-if="showSelected">
          <td colspan="49" class="c-weektime-preview">
            <div class="g-clearfix c-weektime-con">
              <span class="g-pull-left g-tip-text">{{ selectState ? '已选择时间段' : '可拖动鼠标选择时间段' }}</span>
              <a class="g-pull-right" @click.prevent="onClear" v-if="!disabled">清空选择</a>
            </div>

            <ReadableWeekdays v-if="selectState" :list="selectValue"></ReadableWeekdays>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { creteArr, deepCopy } from '@/common/js/utils'
import ReadableWeekdays from './weekdaysTextTransformer.vue'
function splicing(list) {
  let same
  let i = -1
  const len = list.length
  const arr = []

  if (!len) return
  while (++i < len) {
    const item = list[i]
    if (item.check) {
      if (item.check !== Boolean(same)) {
        arr.push(...['、', item.begin, '~', item.end])
      } else if (arr.length) {
        arr.pop()
        arr.push(item.end)
      }
    }
    same = Boolean(item.check)
  }
  arr.shift()
  return arr.join('')
}

export default {
  name: 'dragWeektime',
  components: {
    ReadableWeekdays
  },
  props: {
    value: {
      type: String
    },
    data: {
      type: Array
    },
    colspan: {
      type: Number,
      default() {
        return 2
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    weekdays: {
      // 一周内选中的值数组
      type: Array
    },
    showSelected: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    rowLen() {
      return this.weektimeData[0].child.length
    },
    styleValue() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        left: `${this.left}px`,
        top: `${this.top}px`
      }
    },

    selectValue() {
      return this.valueArr
    },
    selectState() {
      return this.valueArr.some((ret) => ret.value)
    },
    selectClasses() {
      return (n) => (n.check ? 'ui-selected' : '')
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.weektimeData = deepCopy(this.data)
      }
    },
    value() {
      this.setSelectedCol()
    }
  },
  methods: {
    cellEnter(item) {
      const ele = document.querySelector(`td[data-week='${item.row}'][data-time='${item.col}']`)
      if (ele && !this.mode) {
        this.left = ele.offsetLeft
        this.top = ele.offsetTop
      } else {
        if (item.col <= this.col && item.row <= this.row) {
          this.width = (this.col - item.col + 1) * ele.offsetWidth
          this.height = (this.row - item.row + 1) * ele.offsetHeight
          this.left = ele.offsetLeft
          this.top = ele.offsetTop
        } else if (item.col >= this.col && item.row >= this.row) {
          this.width = (item.col - this.col + 1) * ele.offsetWidth
          this.height = (item.row - this.row + 1) * ele.offsetHeight
          if (item.col > this.col && item.row === this.row) this.top = ele.offsetTop
          if (item.col === this.col && item.row > this.row) this.left = ele.offsetLeft
        } else if (item.col > this.col && item.row < this.row) {
          this.width = (item.col - this.col + 1) * ele.offsetWidth
          this.height = (this.row - item.row + 1) * ele.offsetHeight
          this.top = ele.offsetTop
        } else if (item.col < this.col && item.row > this.row) {
          this.width = (this.col - item.col + 1) * ele.offsetWidth
          this.height = (item.row - this.row + 1) * ele.offsetHeight
          this.left = ele.offsetLeft
        }
      }
    },
    cellDown(item) {
      const ele = document.querySelector(`td[data-week='${item.row}'][data-time='${item.col}']`)
      this.check = Boolean(item.check)
      this.mode = 1
      if (ele) {
        this.width = ele.offsetWidth
        this.height = ele.offsetHeight
      }

      this.row = item.row
      this.col = item.col
    },
    cellUp(item) {
      if (item.col <= this.col && item.row <= this.row) {
        this.selectWeek([item.row, this.row], [item.col, this.col], !this.check)
      } else if (item.col >= this.col && item.row >= this.row) {
        this.selectWeek([this.row, item.row], [this.col, item.col], !this.check)
      } else if (item.col > this.col && item.row < this.row) {
        this.selectWeek([item.row, this.row], [this.col, item.col], !this.check)
      } else if (item.col < this.col && item.row > this.row) {
        this.selectWeek([this.row, item.row], [item.col, this.col], !this.check)
      }

      this.width = 0
      this.height = 0
      this.mode = 0

      this.valueArr = this.getValueArr()
    },

    getValueArr() {
      let schedule = ''
      const v = this.weektimeData.map((item) => {
        // 生成一周每天选中的节点，保存到后端回显需要用
        schedule += item.child.map((j) => (j.check ? 1 : 0)).join('')
        return {
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        }
      })

      this.$emit('input', schedule)

      // 回显可读的的字符串
      this.$emit('change', schedule, v)

      return v
    },

    setSelectedCol() {
      const schedule = this.value
      if (schedule) {
        this.weektimeData.forEach((w, pIdx) => {
          // 周一至周日分为7段，每一段48个数字表示是否选中（1为选中0为不选中）
          const range = schedule.slice(pIdx * this.rowLen, this.rowLen * (pIdx + 1))
          w.child.forEach((c, subIdx) => {
            c.check = range[subIdx] === '1'
          })
        })
      } else {
        this.onClear()
      }
    },

    selectWeek(row, col, check) {
      const [minRow, maxRow] = row
      const [minCol, maxCol] = col
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          if (t.row >= minRow && t.row <= maxRow && t.col >= minCol && t.col <= maxCol) {
            this.$set(t, 'check', check)
          }
        })
      })

      // 20220816 新增时段值获取
      const weekdays = this.weektimeData.map((item) => {
        return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
      })
      this.$emit('update:weekdays', weekdays)
    },
    onClear() {
      this.weektimeData = deepCopy(this.data)
      this.valueArr = []

      this.$emit('input', '')
      this.$emit('change', '')
    }
  },
  data() {
    return {
      weektimeData: deepCopy(this.data),
      valueArr: [],
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      mode: 0,
      row: 0,
      col: 0,
      theadArr: []
    }
  },
  created() {
    this.theadArr = creteArr(24)
    this.setSelectedCol()
  }
}
</script>
<style lang="scss" scoped>
.c-weektime {
  min-width: 640px;
  position: relative;
  display: inline-block;
}

.disabled {
  position: relative;
  z-index: 1;

  &:before {
    width: 100%;
    height: 100%;
    content: ' ';
    position: absolute;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 3;
  }
}

.c-schedue {
  background: #598fe6;
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0.6;
  pointer-events: none;
}

.c-schedue-notransi {
  transition: width 0.12s ease, height 0.12s ease, top 0.12s ease, left 0.12s ease;
}

.c-weektime-table {
  border-collapse: collapse;

  tr,
  td,
  th {
    user-select: none;
    border: 1px solid #dee4f5;
    font-size: 12px;
    text-align: center;
    min-width: 12px;
    line-height: 1.8em;
    transition: background 0.2s ease;
  }

  .c-weektime-head {
    .week-td {
      width: 70px;
    }
  }

  .c-weektime-body {
    td {
      &.weektime-atom-item {
        user-select: unset;
        background-color: #f5f5f5;
      }

      &.ui-selected {
        background-color: #598fe6;
      }
    }
  }

  .c-weektime-preview {
    line-height: 2.4em;
    padding: 0 10px;

    .c-weektime-con {
      user-select: none;
    }
  }
}

.c-min-table {
  tr,
  td,
  th {
    min-width: 24px;
  }
}
</style>
